"use client";
import Image from "next/image";
import Link from "next/link";

import footerLogo1 from "@/assets/images/logo/VIBGYORONE.png";
import footerLogo2 from "@/assets/images/logo/logo_01.svg";
import { APP_NAME } from "@/utils/enum";

const FooterFive = ({ data, socialMedia }: any) => {
  const firstIndexClassName = `fa-brands fa-${socialMedia?.[0]?.Title?.toLowerCase() || ""}`;
  const secondIndexClassName = `fa-brands fa-${socialMedia?.[1]?.Title?.toLowerCase() || ""}`;
  const thirdIndexClassName = `fa-brands fa-${socialMedia?.[2]?.Title?.toLowerCase() || ""}`;

  const footerDataa = [
    // `{
    //   id: 4,
    //   page: "home_5",
    //   widget_class: "col-lg-3",
    //   widget_title: "Explore",
    //   footer_link:
    //     process.env.NEXT_PUBLIC_APP_NAME === APP_NAME.VIBGYOR_VIVA
    //       ? [{ link: "/events", link_title: "Events - version 1" }]
    //       : [],
    // },`
    {
      id: 1,
      page: "home_5",
      widget_class: "col-lg-3 ms-auto",
      widget_class2: "ps-xl-5",
      widget_title: "Links",
      footer_link: [
        // { link: "/", link_title: "Home" },
        // { link: "/dashboard/membership", link_title: "Membership" },
        // { link: "/about_us_01", link_title: "About Company" },
        // { link: "/blog_01", link_title: "Blog" },
        // { link: "/blog_02", link_title: "Explore Careers" },
        // { link: "/pricing_02", link_title: "Pricing" },
        // { link: "/dashboard/dashboard-index", link_title: "Dashboard" },
      ],
    },
    {
      id: 2,
      widget_class: "col-lg-3",
      page: "home_5",
      widget_title: "Legal",
      footer_link: [
        // { link: "/faq", link_title: "Terms & conditions" },
        // { link: "/faq", link_title: "Cookie" },
        // { link: "/faq", link_title: "Privacy policy" },
        // { link: "/faq", link_title: "Faq’s" },
      ],
    },
    {
      id: 3,
      widget_class: "col-lg-3",
      page: "home_5",
      widget_title: "Products",
      footer_link: [
        // { link: "/listing_01", link_title: "​​Take the tour" },
        // { link: "/listing_02", link_title: "Live chat" },
        // { link: "listing_03", link_title: "Self-service" },
        // { link: "listing_04", link_title: "Social" },
        // { link: "/listing_05", link_title: "Expert Agent" },
        // { link: "/listing_06", link_title: "Reviews" },
      ],
    },
  ];
  data[0]?.forEach((item: any) => {
    footerDataa[0].footer_link.push({
      link: `${item?.URL}`,
      link_title: `${item?.Title}`,
    });
  });
  data[1]?.forEach((item: any) => {
    footerDataa[1].footer_link.push({
      link: `${item?.URL}`,
      link_title: `${item?.Title}`,
    });
  });
  data[2]?.forEach((item: any) => {
    footerDataa[2].footer_link.push({
      link: `${item?.URL}`,
      link_title: `${item?.Title}`,
    });
  });

  return (
    <div className="footer-four dark-bg position-relative z-1">
      {/* <div className="news-letter-area">
            <div className="container container-large">
               <div className="line-wrapper">
                  <div className="row align-items-center">
                     <div className="col-lg-6">
                        <div className="text-center text-lg-start md-mb-40">
                           <h2 className="text-white">Our Newsletter</h2>
                           <p className="fs-24 text-white opacity-75 m0">Get instant news by subscribe to our newsletter</p>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div className="form-wrapper me-auto ms-auto me-lg-0">
                           <form onSubmit={(e) => e.preventDefault()}>
                              <input type="email" placeholder="Email address" className="rounded-0" />
                              <button className="rounded-0">Get Started</button>
                           </form>
                           <div className="fs-16 mt-10 text-white"><span className="fw-light opacity-75">Already a Agent?</span> <a href="#" data-bs-toggle="modal" data-bs-target="#loginModal">Sign in.</a></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}

      <div className="container container-large">
        <div className="bg-wrapper position-relative z-1">
          <div className="row">
            <div className="col-xl-3 col-lg-4 mb-60">
              <div className="footer-intro">
                <div className="logo mb-20">
                  {process.env.NEXT_PUBLIC_APP_NAME ===
                    APP_NAME.VIBGYOR_VIVA && (
                    <Link href="/">
                      <Image src={footerLogo2} alt="" />
                    </Link>
                  )}
                  {process.env.NEXT_PUBLIC_APP_NAME ===
                    APP_NAME.VIBGYOR_ONE && (
                    <Link href="/">
                      <Image src={footerLogo1} alt="" />
                    </Link>
                  )}
                </div>
                <p className="mb-45 md-mb-20"></p>
                <ul className="style-none d-flex align-items-center social-icon">
                  <li>
                    <Link href={socialMedia?.[0]?.URL || "/"}>
                      <i className={firstIndexClassName}></i>
                    </Link>
                  </li>
                  <li>
                    <Link href={socialMedia?.[1]?.URL || "/"}>
                      <i className={secondIndexClassName}></i>
                    </Link>
                  </li>
                  <li>
                    <Link href={socialMedia?.[2]?.URL || "/"}>
                      <i className={thirdIndexClassName}></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {footerDataa
              .filter((items) => items.page === "home_5")
              .map((item) => (
                <div key={item.id} className={`col-md-4  ${item.widget_class}`}>
                  <div className={`footer-nav ${item.widget_class2}`}>
                    {/* <h5 className="footer-title text-white">
                      {item.widget_title}
                    </h5> */}
                    <ul className="footer-nav-link style-none">
                      {item.footer_link.map((li: any, i) => (
                        <li key={i}>
                          <Link href={li.link}>{li.link_title}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="bottom-footer">
          <p className="m0 text-center fs-16">Copyright @2025 VIBGYOR ONE</p>
        </div>
      </div>
    </div>
  );
};

export default FooterFive;
